import React from 'react';
import { TrendingUp, TrendingDown, Minus } from 'lucide-react';
import Icon from '../../../components/AppIcon';


const MetricCard = ({ title, value, subtitle, icon: Icon, trend = 'neutral' }) => {
  const getTrendIcon = () => {
    if (trend === 'up') return <TrendingUp className="h-4 w-4 text-success" />;
    if (trend === 'down') return <TrendingDown className="h-4 w-4 text-destructive" />;
    return <Minus className="h-4 w-4 text-muted-foreground" />;
  };

  const getTrendColor = () => {
    if (trend === 'up') return 'text-success';
    if (trend === 'down') return 'text-destructive';
    return 'text-muted-foreground';
  };

  return (
    <div className="bg-card border border-border rounded-lg p-4 sm:p-6 hover:shadow-lg transition-shadow">
      <div className="flex items-center justify-between mb-3">
        <div className="p-2 bg-primary/10 rounded-lg">
          <Icon className="h-5 w-5 sm:h-6 sm:w-6 text-primary" />
        </div>
        {getTrendIcon()}
      </div>
      <h3 className="text-sm text-muted-foreground mb-1">{title}</h3>
      <p className="text-2xl sm:text-3xl font-bold text-foreground mb-1">{value}</p>
      <p className={`text-xs sm:text-sm ${getTrendColor()}`}>{subtitle}</p>
    </div>
  );
};

export default MetricCard;